module.exports = "uniform sampler2D posTex;\nuniform sampler2D velTex;\n\nuniform float pointSize;\n\nvarying vec4 parVel;\nvarying vec2 vUv;\n\nvoid main() {\n    vec4 pos = texture2D(posTex, uv);\n    vec4 vel = texture2D(velTex, uv);\n\n    vec4 mvPosition = modelViewMatrix * vec4( pos.xyz, 1.0 );\n    vec4 outputPos = projectionMatrix * mvPosition;\n\n    vUv = uv;\n    parVel = vel;\n    gl_Position = outputPos;\n    gl_PointSize = pointSize * 1.0;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/scene-builder/Details/GPUParticles/particle.vert
// module id = 680
// module chunks = 2